import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const Typewriter = ({ text }) => {
  const [displayText, setDisplayText] = useState('');
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (index < text.length) {
        setDisplayText((prevText) => prevText + text[index]);
        setIndex((prevIndex) => prevIndex + 1);
      } else {
        // Reset index and display text when typing completes
        setTimeout(() => {
            setDisplayText('');
            setIndex(0); 
        }, 10000);
      }
    }, 100); // Adjust typing speed here

    return () => clearTimeout(timer);
  }, [index, text]);

  return <span>{displayText}</span>;
};




const Contact = () => {

  const [sending, setSending] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [error, setError] = useState("");

  const MySwal = withReactContent(Swal)

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // background: '#f2f2f2',
    timer: 4000,
    showCloseButton: true,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });
  
  const handleSubmit = async (event) => {
    setSending(true);
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
  
    try {
      const response = await axios.post(
        // "https://formsubmit.co/ajax/ucboi1.up@gmail.com",
        "https://formsubmit.co/ajax/ucboi1.up@gmail.com",
        Object.fromEntries(formData)
      );
  
      console.log("Form submission successful:", response);
      setSending(false);
      setMessageSent(true);
      setError("");
      form.reset();
      Toast.fire({
        icon: "success",
        title: "Form submission successful"
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setSending(false);
      setMessageSent(false);
      setError("Error submitting form:", error);
      Toast.fire({
        icon: "error",
        title: "Error submitting form"
      });
    }
  };
  
  useEffect(() => {
    if (messageSent || error) {
      setTimeout(() => {
        setMessageSent(false);
        setError("");
      }, 5000);
    }
  }, [messageSent, error]);
  

  return (
    <div className="container-fluid contact">
      <div className="py-5">
        <h5 className="mb-4 ">
          Have a project in mind or want a collaboration?{" "}
          <Typewriter text="Talk to me lets make it happen." />
        </h5>

        <form className=""  onSubmit={handleSubmit}
            method="POST"
            encType="multipart/form-data">

            <input type="hidden" name="_captcha" value="false" />
            <input type="text" name="_honey" style={{ display: "none" }} />

          <div className="form-floating name">
            <input
              type="text"
              name="Name"
              className="form-control"
              id="name"
              placeholder=""
              required
            />
            <label htmlFor="name">Name</label>
          </div>

          <div className="form-floating email mt-3">
            <input
              type="email"
              name="Email"
              className="form-control"
              id="email"
              placeholder=""
              required
            />
            <label htmlFor="name">Email</label>
          </div>

          <div className="form-floating phone mt-3">
            <input
              type="number"
              name="Phone"
              className="form-control"
              id="phone"
              placeholder=""
              required
            />
            <label htmlFor="name">Phone</label>
          </div>

          <div className="form-floating name mt-3">
            <textarea className="form-control" name="Message" placeholder="" id="message"></textarea>
            <label htmlFor="message">Message</label>
          </div>

          <div className="mt-3" >
            <button className={`btn btn-primary  ${sending && "disabled"}`} type="submit" disabled={sending && true}>
              {!sending ? "Submit form" :  <div>Submiting... <span className="spinner-border spinner-border-sm"></span></div>}
            </button>
          </div>
          {messageSent && (
            <div className="mt-3 alert alert-success">
              <i className="bi bi-check-circle-fill position-absolute top-0 end-50 d-flex translate-middle-y fs-1"></i>
              <small >Your Message is received, expect a response as soon as possible 😊</small>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
